import { createContext, useContext } from 'react';
import { AnyPrescriptionJobStrategy } from './PrescriptionJobStrategy';

interface PrescriptionJobStrategyContextType {
  prescriptionJobStrategy: AnyPrescriptionJobStrategy | null;
}

const PrescriptionJobStrategyContext = createContext<
  PrescriptionJobStrategyContextType | undefined
>(undefined);

export const PrescriptionJobStrategyProvider = PrescriptionJobStrategyContext.Provider;

export function usePrescriptionJobStrategy(): AnyPrescriptionJobStrategy | null {
  const context = useContext(PrescriptionJobStrategyContext);

  if (!context) {
    throw new Error('usePrescriptionJobStrategy must be used within a PrescriptionContainer');
  }
  return context.prescriptionJobStrategy;
}
